import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom/cjs/react-router-dom";

import { globalSystemConstants } from "../../../../constants";

const Support = (props) => {
  return (
    <div className="container support-tab py-3">
      <div className="row">
        <div className="col px-0">
          <h5 className="p-0 m-0 mb-1">support</h5>
          <p className="p-0 m-0 mb-3">
            if you have any concerns or require support please contact us and
            someone from our team will be in touch.
          </p>
        </div>
      </div>
      <div className="row">
        <div className="col px-0">
          <button
            type="submit"
            className="btn-simple mb-2"
            onClick={() => {
              props.spinnerActivate();
              window.location.replace(
                `${process.env.REACT_APP_MARKETING_SITE_BASE_URL}/contact-us/`
              );
            }}
          >
            Contact Us
          </button>
        </div>
      </div>
    </div>
  );
};

const mapDispatchToProps = (dispatch) => ({
  spinnerActivate: () => {
    dispatch({
      type: globalSystemConstants.SPINNER_ACTIVATE,
    });
  },
  spinnerDiactivate: () => {
    dispatch({
      type: globalSystemConstants.SPINNER_DIACTIVATE,
    });
  },
});

export default connect(null, mapDispatchToProps)(withRouter(Support));
